import { FC } from 'react';

import { Popover } from 'antd';
import cs from 'classnames';

import styles from './styles.module.scss';

interface CardProps {
  name: string;
  title: string;
  bio: string;
  image: string;
}

const Card: FC<CardProps> = ({ name, title, bio, image }) => {
  return (
    <div className={styles.card}>
      <Popover
        content={<p>{bio}</p>}
        placement="top"
        overlayClassName={styles.popover}
        arrow={{ pointAtCenter: true }}
        align={{ offset: [0, 10] }}
      >
        <div className={cs(styles.imageWrapper, 'dashedBorder')}>
          <img src={image} alt={name} className={styles.image} />
        </div>
      </Popover>
      <div className={styles.info}>
        <p className={styles.title}>{title}</p>
        <h4 className={styles.name}>{name}</h4>
      </div>
    </div>
  );
};

export default Card;
